import { render, staticRenderFns } from "./ReportColumnSelector.vue?vue&type=template&id=82980ea8&"
import script from "./ReportColumnSelector.vue?vue&type=script&lang=js&"
export * from "./ReportColumnSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82980ea8')) {
      api.createRecord('82980ea8', component.options)
    } else {
      api.reload('82980ea8', component.options)
    }
    module.hot.accept("./ReportColumnSelector.vue?vue&type=template&id=82980ea8&", function () {
      api.rerender('82980ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportColumnSelector/ReportColumnSelector.vue"
export default component.exports